module.exports = {
    HOST:'https://colarquiapi.colegiosarquidiocesanos.edu.co', //HOST:'http://190.8.178.46:4000',
    SOCKET_HOST: 'ws://localhost:2000/ws',
    IFRAMES:'http://localhost:8080'
}